import startCase from 'lodash/startCase'
import {mergeConfig, merge} from '../configStore'
import type {FieldsetProps, FieldsetReturn} from '../types'

export const define = (
  name: string,
  props?: FieldsetProps,
  mergeProps?: FieldsetProps,
): FieldsetReturn => {
  const {collapsible = true, collapsed = true, ...rest} = props || {}
  const defineProps: FieldsetProps = merge({options: {collapsible, collapsed}}, rest)

  const defaultProps = {
    title: startCase(name),
  }

  return {name, ...mergeConfig('fieldset', defineProps, mergeProps, defaultProps)}
}
